module.exports = __webpack_public_path__ + "img/pingjia.0a339145.png";